module.exports = __webpack_public_path__ + "img/echannel.5707d67c.svg";